export function createCommaSeparatedListFromArray(array: string[]): string {
    let concatinatedResult = '';

    for (const entry of array) {
        concatinatedResult = concatinatedResult.concat(`${entry},`);
    }

    return concatinatedResult;
}
